angular.module("menus")

    .controller("MenusEditCtrl", ['$scope', '$rootScope', '$controller', '$state', '$q', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', 'uiGridTreeViewConstants', 'treeService', 'LoginService', '$filter', 'logService',
        function ($scope, $rootScope, $controller, $state, $q, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, uiGridTreeViewConstants, treeService, LoginService, $filter, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("MENU_WRITE");

        $rootScope.title = $filter('translate')('menus.title');
        $scope.editCode = true;
        $scope.menu = {};

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('menus.title'), url: "menus.list" },
                { title: $filter('translate')('menus.add') }
            ];
        }
        else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('menus.title'), url: "menus.list" },
                { title: $filter('translate')('menus.edit') }
            ];
            Restangular.one('Menus', $stateParams.id).get().then(function (menu) {
                $scope.menu = menu;
                $scope.editCode = LoginService.permissionExist("P_MODIFY_CODE_MENU");
            });
        }


        $scope.gridOptions = {
            pdfTitle: $filter('translate')('menus.title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            enableSorting: true,
            showTreeExpandNoChildren: true,
            paginationPageSizes: [100, 500, 1000],
            paginationPageSize: 500,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('menus.name'), enableFiltering: true, enableHiding: false },
              { name: 'icon', displayName: $filter('translate')('menus.icon'), enableFiltering: true },
              { name: 'ui_sref', displayName: 'ui_sref', enableFiltering: true },
              { name: 'href', displayName: 'href', enableFiltering: true },
              { name: 'ng_click', displayName: 'ng_click', enableFiltering: true },
              { name: 'permissions_code', field: 'FK_menus_items_permissions.code', displayName: 'Permiso', enableFiltering: true },
              { name: 'position', visible: false, displayName: $filter('translate')('menus.position') },
              {
                  name: 'visible', enableFiltering: true, filter: gridService.yesNoFilter('visible'),
                  displayName: $filter('translate')('menus.visible'), cellTemplate: gridService.yesNoTemplate('visible')
              },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('menus.button_edit'), action: 'ui-sref="menus.menu_item-edit({menu_id:row.entity.menu_id,id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('menus.button_delete'), action: 'ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.menu_id = $stateParams.id;
                var deferred = $q.defer();
                Restangular.all('MenusItems').getList(options).then(function (menusItems) {
                    var treeMenusItems = [];
                    var data = treeService.menuTree(menusItems, null, treeMenusItems);
                    data.totalRows = menusItems.totalRows;

                    deferred.resolve(data);
                });

                return deferred.promise;
            }
        };


        $scope.goToEdit = function (rowEntity) {
            $state.go("menus.menu_item-edit", { menu_id: rowEntity.menu_id, id: rowEntity.id });
        }


        $scope.saveMenu = function () {

            logService.debug($scope.menu);

            if (angular.isDefined($scope.menu.id)) {
                $scope.menu.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        $state.go("menus.list");
                        toastr.success($filter('translate')('menus.edit_success'));
                    }
                });
            } else {
                Restangular.all('menus').post($scope.menu).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('menus.create_success'));
                        $state.go("menus.edit", { id: result.id });
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('menus.button_delete'),
                message: $filter('translate')('menus.delete_message') + " " + $scope.menu.name + "?",
                onAccept: function () {
                    $scope.menu.remove().then(function () {
                        $state.go("menus.list");
                    });
                }
            });
        };

        $scope.BorrarDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('menus.button_delete'),
                message: $filter('translate')('menus.delete_option_message') + " " + $scope.name + " del menú?",
                onAccept: function () {
                    Restangular.one('MenusItems', $scope.id).remove().then(function () {
                        $scope.gridOptions.loadData();
                    });
                }
            });

        };

    }]);